import IGlassArea from 'components/interfaces/IGlassArea';
import IGlassAreaMetaData from 'components/interfaces/IGlassAreaMetaData';
import IWall from 'components/interfaces/IWall';
import { getGlassMaxLength } from 'components/configurator/services/glassWeight';
import { hasElementWall } from 'components/configurator/types/wallTypes';

import {
  MANUAL,
  QUANTITY,
} from 'services/constants/glassWidthCalculationTypes';

import calculateManualGlassLastGlassLength from './glassAreas/calculateManualGlassLastGlassLength';

const getQuantity = (
  length: number,
  wall: IWall,
  glassAreaMetaData: IGlassAreaMetaData
): number => {
  if (glassAreaMetaData.calculationType === QUANTITY) {
    return glassAreaMetaData.quantity === null ? 1 : glassAreaMetaData.quantity;
  }

  const maxWeight =
    glassAreaMetaData.maxWeight === null ? 1 : glassAreaMetaData.maxWeight;

  return Math.ceil(length / getGlassMaxLength(maxWeight, wall));
};

const getGlassWidths = (
  length: number,
  wall: IWall,
  glassArea: IGlassArea,
  glassAreaMetaData: IGlassAreaMetaData
): number[] => {
  if (Number.isNaN(length)) {
    return [];
  }

  if (glassAreaMetaData.calculationType === MANUAL) {
    const glassWidths = glassArea.glasses.map((glass) => glass.width);
    if (glassWidths.length === 0) {
      return glassWidths;
    }

    glassWidths[glassWidths.length - 1] = calculateManualGlassLastGlassLength(
      glassArea,
      length,
      wall
    );

    return glassWidths;
  }

  const quantity = getQuantity(length, wall, glassAreaMetaData);

  if (quantity <= 1) {
    return [length];
  }

  let glassSpacing = 0;
  if (!hasElementWall(wall)) {
    glassSpacing = window.CommonFunctions.GetGlassGlassSpacing();
  }

  const lengthWithoutGlassSpacing = length - glassSpacing * (quantity - 1);
  const singleGlassWidth = lengthWithoutGlassSpacing / quantity;

  return Array.from(Array(quantity)).map(() => singleGlassWidth);
};

export default getGlassWidths;
